export default {
    state: {
        default: {
            id: 0,
            user: null,
            userId: 0,
            competence: null,
            previousMonthBalance: null,
            input: null,
            outputDistributed: null,
            currentBalance: 0,
            quantityRequested: null,
            supplyId: 0,
            supply: null,
            statusId: 0,
            status: null,
            observation: null,
        },
        data: {

        },
    },

    getters: {
        getLubricantSolicitationData(state) {
            return state.data;
        },
        getDefaultLubricantSolicitationData(state) {
            return state.default;
        },
    },

    mutations: {
        resetOrPersistLubricantSolicitationData(state, data) {
            state.data = data;
        },

    },

    actions: {
        changeLubricantSolicitationData(context, info) {
            context.commit("resetOrPersistLubricantSolicitationData", info);

        },

    },

}

// modulo toda hora volta o nome em mauisculo                                                     